import api from './apiService';

export interface GenerateReportPayload {
  reportType: string;
  tenantId: string;
  tenantName: string;
  tenantGroupName: string;
  tenantGroupId: string;
  correlationId: string;
  requestedAtUtc: string;
}

export interface GenerateReportResponse {
  isSuccess: boolean;
  message: string;
  data?: any;
  errorCode?: string | null;
  statusCode: string;
}

// New types for report list
export interface ReportListItem {
  blobName: string;
  reportType: string;
  tenantName: string;
  tenantGroupName: string;
  expiryTime: string;
  lastModified: string;
  relativeUrl: string;
  size: number;
  metadata: {
    expiryTime: string;
    tenantId: string;
    tenantGroupId: string;
    reportType: string;
    tenantName: string;
    tenantGroupName: string;
  };
}

export interface ReportListResponse {
  data: ReportListItem[];
  message: string;
  isSuccess: boolean;
  errorCode?: string | null;
  statusCode: string;
}

export interface LatestReportByTenantsResponse {
  data: any; // You can define a more specific type if you know the structure
  message: string;
  isSuccess: boolean;
  errorCode?: string | null;
  statusCode: string;
}
export const generateReport = async (payload: GenerateReportPayload): Promise<GenerateReportResponse> => {
  const response = await api.post<GenerateReportResponse>('/dashboardservice/report/generate', payload);
  return response.data;
};

export const getReportList = async (tenantId: string, tenantGroupId?: string, reportType?: string): Promise<ReportListResponse> => {
  let url = `/dashboardservice/Report/list/${tenantId}`;
  if (tenantGroupId) url += `?tenantGroupId=${tenantGroupId}`;
  if (reportType) url += `${tenantGroupId ? '&' : '?'}reportType=${reportType}`;
  const response = await api.get<ReportListResponse>(url);
  return response.data;
};

export const getLatestReportByTenants = async (tenantIds: string[], reportType: string): Promise<LatestReportByTenantsResponse> => {
  const url = `/dashboardservice/Report/latest-by-tenants?reportType=${encodeURIComponent(reportType)}`;
  const response = await api.post<LatestReportByTenantsResponse>(url, tenantIds);
  return response.data;
};
